module.exports = __webpack_public_path__ + "static/media/attendance-empty.7c8129b1.svg";